import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Row from "../../common/Row";
import Fieldset from "../../common/Fieldset";
import TextInput from "../../common/TextInput";
import DateInput from "../../common/DateInput";
import SelectInput from "../../common/SelectInput";
import JaNeeRadioButtonGroup from "../../common/JaNeeRadioButtonGroup";
import Section from "../../common/Section";

const IdentificatieForm = (props) => {
    const {
        goToNext,
        goToPrev,
        model,
        onChange,
        errors,
        validationMessageType,
        rechtsvormen,
        datumOprichtingHasFocus
    } = props;

    return (
        <Section>
            <Form
                name="identificatie"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Ga verder"
                leftButtonLabel="Terug"
                onRightButtonClick={goToNext}
                onLeftButtonClick={goToPrev}
            >
                <Fieldset>
                    <Row><div style={{ color: "#082b42", fontSize: "1.4375rem", fontWeight: "500", lineHeight: "28px", margin: "30px 0.83333% 0 0.83333%" }}>Identificatiegegevens</div></Row>
                </Fieldset>
                <div style={{ width: "100%", height: "1px", backgroundColor: "#E6E6E6", marginTop: "30px" }}></div>
                <Fieldset>
                    <Row>
                    <DateInput
                            name="oprichtDatum"
                            label="Datum oprichting"
                            value={model.oprichtDatum}
                            onChange={onChange}
                            validationMessage={errors ? errors['oprichtDatum'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            hasFocus={datumOprichtingHasFocus}
                        />
                        <TextInput
                            name="ondernemingsnummer"
                            label="Ondernemingsnummer"
                            value={model.ondernemingsnummer}
                            onChange={onChange}
                            validationMessage={errors ? errors['ondernemingsnummer'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            optional
                            isOndernemingsnummer
                        />
                    </Row>
                    <Row>
                        <SelectInput
                            name="rechtsvorm"
                            label="Rechtsvorm"
                            value={model.rechtsvorm}
                            size={6}
                            items={rechtsvormen}
                            onChange={onChange}
                            validationMessage={errors ? errors["rechtsvorm"] : ""}
                            validationMessageType={validationMessageType}
                            defaultItem="De feitelijke vereniging" />
                    </Row>
                    <Row>
                        <JaNeeRadioButtonGroup
                            name="isAangeslotenBijSportfederatie"
                            label="Ben je aangesloten bij een sportfederatie?"
                            key={"isAangeslotenBijSportfederatie"}
                            value={model.isAangeslotenBijSportfederatie}
                            onChange={onChange}
                            validationMessage={errors ? errors['isAangeslotenBijSportfederatie'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                            horizontal
                        />
                    </Row>
                    <Row>
                        {(model.isAangeslotenBijSportfederatie === "false" || model.isAangeslotenBijSportfederatie === false) ||
                        <TextInput
                            name="naamSportfederatie"
                            label="Sportfederatie"
                            value={model.naamSportfederatie}
                            onChange={onChange}
                            validationMessage={errors ? errors['naamSportfederatie'] : ""}
                            validationMessageType={validationMessageType}
                            size={6}
                        />}
                    </Row>
                </Fieldset>
            </Form>
        </Section>
    );
};

IdentificatieForm.propTypes = {
    goToNext: PropTypes.func,
    goToPrev: PropTypes.func,
    model: PropTypes.object,
    onChange: PropTypes.func,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    datumOprichtingHasFocus: PropTypes.bool,
    rechtsvormen: PropTypes.array.isRequired
};

export default IdentificatieForm;